export default class ProdutoPedido {
  constructor(id = 0, idProduto = "", nomeProduto = "", quantidade = 0, precoVenda = 0, referencia = "", grade = "") {
    ;(this.id = id), (this.idProduto = idProduto), (this.nomeProduto = nomeProduto), (this.quantidade = quantidade)
    this.precoVenda = precoVenda
    this.referencia = referencia
    this.grade = grade
  }
}
